import { fn as o } from "../common.js";
import { boolOrFalse as t, boolOrTrue as n } from "../value/bool.js";
const b = (e, r = !1) => ({
  writable: t(r),
  enumerable: !0,
  value: e
}), m = (e, r = !0) => ({
  enumerable: n(r),
  get: e
}), p = o(Object.prototype.hasOwnProperty);
export {
  b as enumerable,
  m as getter,
  p as hasOwnProperty
};
